<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>分地区、户口登记地的常住人口</div>
      <div class="two">
        <div class="one">
          <span>{{ rows.czrk }}</span
          ><span>(人)</span>
          <div>常住人口</div>
        </div>
        <div class="one">
          <span>{{ rows.bxzjd }}</span
          ><span>(人)</span>
          <div>本乡镇街道</div>
        </div>
        <div class="one">
          <span>{{ rows.bqqtxzjd }}</span
          ><span>(人)</span>
          <div>本区其他乡镇街道</div>
        </div>
        <div class="one">
          <span>{{ rows.bsqtq }}</span
          ><span>(人)</span>
          <div>本市其他区</div>
        </div>
        <div class="one">
          <span>{{ rows.wss }}</span
          ><span>(人)</span>
          <div>外省市</div>
        </div>
        <div class="one">
          <span>{{ rows.hkdd }}</span
          ><span>(人)</span>
          <div>户口待定</div>
        </div>
        <div class="one">
          <span>{{ rows.gatjgw }}</span
          ><span>(人)</span>
          <div>港澳台及国外</div>
        </div>
        <div class="one">
          <span>{{ rows.czwlrk }}</span
          ><span>(人)</span>
          <div>常住外来人口</div>
        </div>
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>各社区常住人口</p>
      <div ref="echartsINof" class="echarts" style="height: 38vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj, czrk } from "@/network";
export default {
  data() {
    return {
      rows: {},
    };
  },
  created() {},
  mounted() {
    this.getInfoList();
    this.getInfoData();
    this.handEchart();
  },
  methods: {
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_czrk",
        streetCode: "110105011",
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      var datas = data.sort(compare("czrk")); //通过Id排序完成后的数组
      let czrk = [];
      let villages_name = [];
      for (const item of datas) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
      }
      this.handEchart(czrk, villages_name);
    },
    async getInfoList() {
      const { code, rows, total } = await czrk({villagesCode: "110105011"});
      this.rows = rows[0];
    },
    handEchart(e, es) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        color: "#FF6900",
        tooltip: {
          formatter: "{b} : {c} 人",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: es,
            axisLabel: { interval: 0, rotate: 60 },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        textStyle: {
          color: "#fff",
        },
        series: [
          {
            data: e,
            type: "bar",
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: rgb(255, 255, 255);
      text-align: center;
      font-size: 18px;
      padding: 1vh;
    }
    .echarts {
      margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .two {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      width: 6.5vw;
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
